import { Card, TimelinePrimitive } from "@swot/base-components";
import type { ComplaintTimelineItemDto } from "../../../types/complaint.types.js";

export function CmtsComplaintTimeline({ items }: { readonly items?: readonly ComplaintTimelineItemDto[] | undefined }) {
  const rows = items ?? [];
  return (
    <Card>
      <div className="space-y-6">

        {/* Header */}
        <div className="border-b pb-4">
          <h2 className="text-xl font-bold text-slate-800">
            Complaint Timeline
          </h2>

          <p className="mt-1 text-sm text-slate-500">
            Complete workflow history from the backend.
          </p>
        </div>

        {/* Empty State */}
        {rows.length === 0 ? (

          <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 py-12 text-center">

            <div className="text-5xl">
              📋
            </div>

            <h3 className="mt-4 text-lg font-semibold text-slate-700">
              No Timeline Available
            </h3>

            <p className="mt-2 text-sm text-slate-500">
              Backend has not returned any lifecycle events.
            </p>

          </div>

        ) : (

          <div className="relative border-l-2 border-slate-200 pl-8">

            {rows.map((item, index) => (

              <div
                key={`${item.actionCode}-${index}`}
                className="relative mb-8"
              >

                {/* Timeline Dot */}
                <div
                  className={`absolute -left-[42px] flex h-7 w-7 items-center justify-center rounded-full border-4 border-white shadow
              ${item.applied
                      ? "bg-green-500"
                      : "bg-red-500"
                    }`}
                />

                {/* Timeline Card */}
                <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition hover:shadow-md">

                  <div className="flex items-center justify-between">

                    <h3 className="text-lg font-semibold text-slate-800">
                      {item.actionCode}
                    </h3>

                    <span
                      className={`rounded-full px-3 py-1 text-xs font-semibold
                  ${item.applied
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                        }`}
                    >
                      {item.applied ? "Applied" : "Rejected"}
                    </span>

                  </div>

                  <div className="mt-3 grid gap-2 text-sm text-slate-600">

                    <div>
                      <span className="font-medium">
                        Date :
                      </span>{" "}
                      {new Date(item.appliedAtUtc).toLocaleString()}
                    </div>

                    <div>
                      <span className="font-medium">
                        Entity :
                      </span>{" "}
                      {item.entityType}
                    </div>

                    {item.sideEffectsQueued && (

                      <div className="inline-flex w-fit rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700">
                        ⚡ Side Effects Queued
                      </div>

                    )}

                  </div>

                </div>

              </div>

            ))}

          </div>

        )}

      </div>
    </Card>
  );
}
